import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { window } from 'browser-monads';
import FdfForm from './FdfForm';

class PlayBehaviorCommonForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const selectedPlayBehavior = this.props.selectedPlayBehavior;
        let behaviorType = null

        if(selectedPlayBehavior.behaviorType == "fdf") {
            behaviorType = "flat-decrease-flat"
        } else {
            window.alert("Something is wrong with the hand range model type...")
        }

        return (
            <Form>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Model Name
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={selectedPlayBehavior.name}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Model Type
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={behaviorType}/>
                    </Col>
                </Form.Group>

                { selectedPlayBehavior.isCommon && (
                    <Row className="text-left pt-3 pb-3 font-12">
                        <Col xs="0" md="1"></Col>
                        <Col xs="12" md="10">
                            Note: This is a common hand range model accessible to all premium members.
                            Thus, it cannot be edited.
                        </Col>
                        <Col xs="0" md="1"></Col>
                    </Row>
                )}

                <FdfForm selectedPlayBehavior={selectedPlayBehavior}/>
            </Form>
        )
    }
}

export default PlayBehaviorCommonForm;